import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeFirebase } from './Firebase'; // Import the initializer

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * Creates an async function to run the initialization.
 * This ensures that Firebase is fully set up before your React app mounts.
 */
const startApp = async () => {
  // Await the Firebase initialization before rendering the app.
  // This populates FIREBASE_AUTH and prevents the 30-second hang.
  await initializeFirebase();

  // Render the app only after initialization is complete.
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Call the async startup function.
startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();